import { ReactNode, useState } from 'react'
import cn from 'classnames'

import Board from 'src/icons/board.webp'
import Mushroom from 'src/icons/mushroom.gif'

import { ContentSteps } from 'src/lib/useStepFlow'
import {
    TextLandDe,
    TextLandEn,
    TextLandRo,
    TextLandEs,
    TextLandFr,
    TextLandIt,
    TextLandPt,
    TextLandEl,
    TextLandSl,
} from './text-second-step'

import { textBtn } from './mock'
import styles from './styles.module.scss'
import { CustomButton } from '../../button/CustomButton'
import { TLang } from 'src/constants/langs'

type TProps = {
    onNext: (step: ContentSteps) => void
    step: ContentSteps
    lang: TLang
}

const textByLang: Record<string, ReactNode> = {
    en: <TextLandEn />,
    ro: <TextLandRo />,
    de: <TextLandDe />,
    es: <TextLandEs />,
    fr: <TextLandFr />,
    it: <TextLandIt />,
    pt: <TextLandPt />,
    el: <TextLandEl />,
    sl: <TextLandSl />,
}

export const SecondStep = ({ onNext, step, lang }: TProps) => {
    const [goodBye, setGoodBye] = useState(false)

    const renderTextContent = textByLang[lang] ?? <TextLandEn />

    const getBtnTextByLang = () => {
        const foundText = textBtn.find((item) => item.lang === lang)

        return foundText ? foundText.text : ''
    }

    const handleClick = () => {
        setGoodBye(true)
        setTimeout(() => {
            onNext(step)
        }, 300)
    }

    return (
        <div
            className={cn(styles.root, styles[`root__${lang}`], {
                [styles.hello]: !goodBye,
                [styles.good_bye]: goodBye,
            })}
            style={{ backgroundImage: `url(${Board})` }}
        >
            <div
                className={cn(styles.wrappper, {
                    [styles[`wrappper--${lang}`]]: lang === 'en',
                })}
            >
                <img
                    src={Mushroom}
                    alt="MushroomLeft"
                    className={cn(styles.mushroom, styles.mushroomLeft)}
                />
                <img
                    src={Mushroom}
                    alt="MushroomRight"
                    className={cn(styles.mushroom, styles.mushroomRight)}
                />
                <div
                    className={cn(styles.content_text_wrapper, {
                        [styles[`content_text_wrapper--${lang}`]]:
                            lang === 'en' ||
                            lang === 'de' ||
                            lang === 'el' ||
                            lang === 'sl',
                        [styles[`content_text_wrapper--common`]]:
                            lang === 'fr' || lang === 'it' || lang === 'pt',
                    })}
                >
                    {renderTextContent}
                </div>
                <div
                    className={cn(
                        styles.wrapper_button,
                        styles[`wrapper_button--${lang}`],
                    )}
                    onClick={handleClick}
                >
                    <CustomButton
                        textBtn={getBtnTextByLang()}
                        classNames={{ textBtn: styles.text_btn }}
                    />
                </div>
            </div>
        </div>
    )
}
